import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCompass } from '@fortawesome/free-solid-svg-icons'

// bingkai tooltip tour: header berisi nama tugas + posisi langkah
const StepFrame = ({ title, current, total, children }) => {
  return (
    <div style={{ minWidth: '300px' }}>
      {/* padding kanan memberi ruang untuk tombol close bawaan reactour */}
      <div className='d-flex align-items-center' style={{ padding: '14px 44px 14px 16px' }}>
        <FontAwesomeIcon icon={faCompass} className='text-primary flex-shrink-0 mr-2' style={{ fontSize: 18 }} />
        <h6 className='mb-0 mr-2 text-truncate' style={{ fontWeight: 700 }}>{title}</h6>
        <span className='ml-auto text-muted flex-shrink-0' style={{ fontSize: 12 }}>{current} / {total}</span>
      </div>
      <hr className='m-0' />
      {children}
    </div>
  )
}

export default StepFrame
